module.exports = __webpack_public_path__ + "img/0115.82ffa8fa.png";